import React , { useState , useEffect} from "react";
import { baseUrl } from "../../utils.jsx/baseUrl";
import axios from 'axios'
const token = sessionStorage.getItem('token');
import { OriginIcon , DropIcon } from "../svg/icons/icon";
import GoogleMaps from "./GoogleMaps";
import { SortingDownIcon , SortingUpIcon } from "../svg/icons/icon";

function minutesDiff(updatedDate, createdDate) {
  const differenceInMs = Math.abs(updatedDate - createdDate);
  const totalHours = Math.floor(differenceInMs / (1000 * 60 * 60));

if (totalHours > 24) {
  const days = Math.floor(totalHours / 24);
  // const hours = totalHours % 24;
  if(days == 1) return `${days} day`
  if(days > 1) return `${days} days`
} else if (totalHours > 0) {
     if(totalHours == 1) return `${totalHours} hr.`
  return `${totalHours} hrs.`
} else {
  const totalMinutes = Math.floor(differenceInMs / (1000 * 60));
  return `${totalMinutes} min.`
}

}



const Table = ({ headers , data , isSearch , hasDestination }) => {
  const [showDetailIndex, setShowDetailIndex] = useState(null); 
  const [singleLoad , setSingleLoad]  = useState();
  const [showMap , setShowMap] = useState(false);
  const toggleDescription = (index , id) => {
    setShowDetailIndex(showDetailIndex === index ? null : index); 
    (async() =>{
      try{
        const url = `${baseUrl.url}/loads/get/${id}`
        const response = await axios.get(url , {
            headers : {
              Authorization : `Bearer ${token}`,
            }
        })
        setSingleLoad(response.data)
      }catch(error){
        console.log(error)
      }
    })()
  };

function formatPhoneNumber(phoneNumber) {
  let cleaned = String(phoneNumber).replace(/\D/g, '');
  let formatted = cleaned.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
  return formatted;
}

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

  return (
    <table className="mt-10 min-w-full bg-white rounded-2xl font-sans">
      <thead>
        <tr className="shadow-2xl mb-1 cursor-pointer border-b-2 rounded-2xl border-gray-300">
          {headers.map((item, index) => (
            <th key={index} className="whitespace-nowrap mb-4 text-left px-4 py-4">
  <span className="flex flex-row items-center">
    {item}
  </span>
</th>

          ))}
          {isSearch && <th className="whitespace-nowrap mb-1 text-left px-4 py-4">DH(Origin)</th>}
          {isSearch && hasDestination && <th className="whitespace-nowrap mb-1 text-left px-4 py-4">DH(destination)</th>}
        </tr>
      </thead>
      <tbody>
        {data?.docs?.length != 0  && data?.docs?.map((row, index) => (
          <React.Fragment key={index}>
            {/* Main Row */}                           
            <tr
            className={` ${showDetailIndex === index ? "bg-[#D8F1FF] cursor-pointer" : "odd:bg-[#F7FBFF] cursor-pointer"}`}
              onClick={() => {
                toggleDescription(index , row._id)
              }}
            >
              {/* <td className = "whitespace-nowrap text-center  px-4 py-4">{row["tracking-number"]}</td> */}
              <td className="whitespace-nowrap text-left px-4 py-4">{`${row.origin.city}, ${row.origin.state}`}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{`${row.destination.city}, ${row.destination.state}`}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{row.equipmentFullName}</td>
              <td className="whitespace-nowrap text-left px-4 py-4">{row.loadsize.weight} </td> 
              <td className="whitespace-nowrap text-left  px-4 py-4">{row.rate}</td>
              {/* <td className="px-4 py-4">{row.distance}</td> */}
               {/* <td className="whitespace-nofswrap text-left px-4 py-4">{row.user.CompanyName}</td> */}
               <td className = "whitespace-nowrap text-left px-4 py-4 max-w-[155px] truncate overflow-hidden text-ellipsis">{capitalizeFirstLetter(row.user.CompanyName)}</td>
               <td className="whitespace-nowrap text-left px-4 py-4">{`${row.origin["date-start"].month}-${row.origin["date-start"].day}-${row.origin["date-start"].year}`}</td>
               <td className="whitespace-nowrap text-left px-4 py-4">{minutesDiff(new Date(row.updatedAt) , new Date())}</td> 
               <td className="whitespace-nowrap text-left px-4 py-4">{row.distance}</td>
              {isSearch &&  <td className="whitespace-nowrap text-left px-4 py-4">{row.deadHead}</td>}
              {isSearch && row["destDeadHead"] &&  <td className="whitespace-nowrap text-left px-4 py-4">{row.destDeadHead}</td>}
               
            </tr>

            {/* Hidden Row */}
            {showDetailIndex === index && (
              <tr className = "bg-[#D8F1FF]">
                <td colSpan={isSearch && hasDestination ? headers.length + 2 : isSearch ? headers.length + 1 : headers.length} className="bg-[#D8F1FF] p-2">
                  <div className="bg-white px-2 py-1  rounded grid grid-cols-2 justify-stretch  gap-10 ">
                     <div className = "flex flex-col p-2">
                       <h1 className = "text-2xl"><strong>{capitalizeFirstLetter(singleLoad?.user?.CompanyName)}</strong></h1>
                       <div className = 'pt-4  grid grid-cols-2 justify-stretch'>
                       <div className = " pr-6  border-r-2 ">                                                        
                          <span className = "text-[12px] text-[#258CFB] ">Company Details</span>
                          <div className="pt-2">
                           <div className = "flex flex-row  justify-between">
                          <span className = "text-[#737373] text-[14px]">Email:</span>
                          <span className = "text-[14px]">{capitalizeFirstLetter(singleLoad?.user?.ContactEmail)}</span>
                          </div>
                          <div className="flex flex-row  justify-between">
                          <span className = "text-[#737373] text-[14px]">Phone Number: </span>
                          <span className = "text-[14px]">{formatPhoneNumber(singleLoad?.user?.ContactPhone)}</span>
                          </div>
                          {/* <div className = "flex flex-row  justify-between">
                          <span className = "text-[#737373] text-[14px]">Address: </span>
                          <span className = "text-[14px]">{capitalizeFirstLetter(singleLoad?.user?.ContactName)}</span>
                          </div> */}
                          </div>
                       </div>
                      <div className = "pl-6"> 
                         <span className = "text-[12px] text-[#258CFB]">Other Details</span>
                         <div className = "pt-2">
                         <div className="flex flex-row justify-between">
                          <span className = "text-[#737373] text-[14px]">Total Load:</span>
                          <span className = "text-[14px]">{singleLoad?.loadsize?.fullload ? "Full" : "Partial" }</span>
                          </div>
                          <div className="flex flex-row justify-between">
                          <span className = "text-[#737373] text-[14px]">Dispatcher:</span>
                          <span className = "text-[14px]">{capitalizeFirstLetter(singleLoad?.user?.ContactName)}</span>
                          </div>
                          </div>
                       </div>
                       </div>
                   </div>
                   <div className = "flex flex-row p-2">
                    <div className = 'pt-4  grid grid-rows-2 justify-stretch'>
                    <span>Location Range</span>
                    <div className = "flex flex-col pr-6">
                      <span className = "flex flex-row gap-2 text-[12px] text-[#737373]">
                        <span className = ""><OriginIcon /></span>
                        <span>Pickup from</span>
                        </span>

                    {singleLoad && singleLoad.origin && singleLoad.origin.city &&  <span className = "text-[14px] pl-5">{`${singleLoad.origin.city} , ${singleLoad.origin.state}`}</span>}
                    </div>
                    <div className = "border-l-2 border-dotted m-1"></div>
                    <div className = "flex flex-col pr-6 pt-2 ">
                    <span className = "flex flex-row gap-2 text-[12px] text-[#737373]">
                      <span className = ""><DropIcon /></span>
                      <span>Dropoff at</span>
                      </span>
                     {singleLoad && singleLoad.destination && singleLoad.destination.city &&  <span className = "text-[14px] pl-5">{`${singleLoad.destination.city} , ${singleLoad.destination.state}`}</span>}

                    </div>
                  <button className="h-[38px] w-max p-4 bg-[#258CFB] mt-2 flex justify-center items-center rounded-lg text-[#ffffff]" onClick = {()=>setShowMap(!showMap)}>{showMap ? "Hide Map route" : "Show map route"}</button>

                  </div>
                  <div className = "">
                   {showMap &&

                  <div className = "w-[400px]"> <GoogleMaps  origin = {singleLoad.origin} destination = {singleLoad.destination}/> </div>
                }
                </div>
                   </div>
                  </div>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))
    
      }
      {data?.docs?.length == 0  && 
       <tr>
        <td colSpan={headers.length} className="px-4 py-4 m-4 text-center">
            No matching loads found. Try adjusting your search criteria   
        </td>
         </tr>
      }

     
       
      </tbody>
    </table>
  );
};

export default Table;

